import React from "react";
import DesktopScreenAtm from "./DesktopScreenAtm";
import { desktopScreenSizes, mobileScreenSizes, tabletScreenSizes } from "./DeviceScreenMol.config";
import { DeviceScreen, StyledTemplateImage, StyledTemplateImageWrapper, IframeWrapper } from "./DeviceScreenMol.styled";
import MobileScreenAtm from "./MobileScreenAtm";
import TabletScreenAtm from "./TabletScreenAtm";

// eslint-disable-next-line no-shadow
export var Devices = /*#__PURE__*/function (Devices) {
  Devices["DESKTOP"] = "desktop";
  Devices["TABLET"] = "tablet";
  Devices["MOBILE"] = "mobile";
  return Devices;
}({});
function DeviceScreenMol(_ref) {
  var activeDevice = _ref.activeDevice,
    templateTitle = _ref.templateTitle,
    templateLink = _ref.templateLink,
    templateImage = _ref.templateImage;
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, templateLink ? /*#__PURE__*/React.createElement(IframeWrapper, null, /*#__PURE__*/React.createElement("iframe", {
    src: templateLink,
    title: templateTitle
  })) : null, !templateLink && templateImage ? /*#__PURE__*/React.createElement(StyledTemplateImageWrapper, null, activeDevice === Devices.DESKTOP && /*#__PURE__*/React.createElement(StyledTemplateImage, {
    srcData: templateImage.large,
    alt: templateImage.large.alt
  }), activeDevice === Devices.TABLET && /*#__PURE__*/React.createElement(StyledTemplateImage, {
    srcData: templateImage.medium,
    alt: templateImage.medium.alt
  }), activeDevice === Devices.MOBILE && /*#__PURE__*/React.createElement(StyledTemplateImage, {
    srcData: templateImage.small,
    alt: templateImage.small.alt
  })) : null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, activeDevice === Devices.DESKTOP && /*#__PURE__*/React.createElement(DeviceScreen, {
    $activeDevice: activeDevice,
    $width: desktopScreenSizes.width,
    $height: desktopScreenSizes.height
  }, /*#__PURE__*/React.createElement(DesktopScreenAtm, null, content)), activeDevice === Devices.TABLET && /*#__PURE__*/React.createElement(DeviceScreen, {
    $activeDevice: activeDevice,
    $width: tabletScreenSizes.width,
    $height: tabletScreenSizes.height
  }, /*#__PURE__*/React.createElement(TabletScreenAtm, null, content)), activeDevice === Devices.MOBILE && /*#__PURE__*/React.createElement(DeviceScreen, {
    $activeDevice: activeDevice,
    $width: mobileScreenSizes.width,
    $height: mobileScreenSizes.height
  }, /*#__PURE__*/React.createElement(MobileScreenAtm, null, content)));
}
export default DeviceScreenMol;